import AlertVertical from './AlertVertical'

export default AlertVertical
